import toast from 'react-hot-toast'
import { createElement } from 'react'

type ToastOptions = {
  title: string
  description?: string
}

function toastContent(options: string | ToastOptions) {
  if (typeof options === 'string') return options
  if (!options.description) return options.title
  return createElement('div', null,
    createElement('strong', { style: { display: 'block', marginBottom: 2 } }, options.title),
    createElement('span', { style: { fontSize: '0.85em', opacity: 0.85 } }, options.description),
  )
}

export const showToast = {
  success: (options: string | ToastOptions) =>
    toast.success(toastContent(options)),
  error: (options: string | ToastOptions) =>
    toast.error(toastContent(options)),
  loading: (options: string | ToastOptions) =>
    toast.loading(toastContent(options)),
}
